import { types } from "../types/types";
import { getBuscarEmpleado, getColumnaFiltrarEmpleados } from "src/services/APIService";
import { finishLoading, startLoading, finishLoadingDepartamento, startLoadingDepartamento, startLoadingCargo, finishLoadingCargo, startLoadingSucursal, finishLoadingSucursal } from "./ui";


export const loadDepartamentos = (parametro) => {

    return (dispatch) => {
        dispatch(startLoadingDepartamento());
        getColumnaFiltrarEmpleados(parametro)
            .then(
                data => {
                    if (!data.error) {
                        dispatch(setDepartamentos(data.datos));
                    } else if (data.error) {
                        console.log(data);
                    } else {
                        console.log(data);
                    }
                    dispatch(finishLoadingDepartamento());
                }
            )

    }
}

export const setDepartamentos = (data) => ({
    type: types.empSetDepartamentos,
    payload: data

})

export const loadCargos = (parametro) => {

    return (dispatch) => {

        dispatch(startLoadingCargo());
        getColumnaFiltrarEmpleados(parametro)
            .then(
                data => {
                    if (!data.error) {
                        dispatch(setPuestos(data.datos));
                    } else if (data.error) {
                        if (data.status === 404) {
                            dispatch(setBusqueda([]));
                        }
                    } else {
                        console.log(data);
                    }
                    dispatch(finishLoadingCargo());
                }
            )
    }
}

export const setPuestos = (data) => ({
    type: types.empSetPuestos,
    payload: data

})


export const loadBusqueda = (parametros) => {

    return (dispatch) => {
        dispatch(startLoading());
        getBuscarEmpleado(parametros)
            .then(
                data => {
                    if (!data.error) {
                        dispatch(setBusqueda(data.datos))
                    } else if (data.error) {
                        if (data.status === 404) {
                            dispatch(setBusqueda([]));
                        }
                    } else {
                        console.log(data);
                    }
                    dispatch(finishLoading());
                }
            )
    }
}



export const setBusqueda = (data) => ({
    type: types.empSetBusqueda,
    payload: data

})




export const loadSucursales = (parametros) => {

    return (dispatch) => {
        dispatch(startLoadingSucursal());
        getColumnaFiltrarEmpleados(parametros)
            .then(
                data => {
                    if (!data.error) {
                        dispatch(setSucusales(data.datos))
                    } else if (data.error) {
                        if (data.status === 404) {
                            dispatch(setSucusales([]));
                        }
                    } else {
                        console.log(data);
                    }
                    dispatch(finishLoadingSucursal());
                }
            )
    }
}



export const setSucusales = (data) => ({
    type: types.empSetSucursal,
    payload: data

})